import { createAction } from '@reduxjs/toolkit';
import { isEmpty } from 'ramda';
import { fetchData as fetchUserInfoAction } from '../../../Home/actions';
import { getApplicationIsConvergent } from '../selectors';
import { getPricePeriod } from '../../../Home/selectors';

import { FETCH_DATA, FETCH_DATA_ERROR, FETCH_DATA_SUCCESS } from '../../constants';
import { getFTTBStatusRequest } from '../../api/requests';

export const fetchDataStart = createAction(FETCH_DATA);
export const fetchDataSuccess = createAction(FETCH_DATA_SUCCESS);
export const fetchDataError = createAction(FETCH_DATA_ERROR);

export function fetchData() {
  return async (dispatch) => {
    dispatch(fetchDataStart());

    getFTTBStatusRequest()
      .then(({ data }) => dispatch(fetchDataSuccess(data)))
      .catch((error) => !isEmpty(error) && dispatch(fetchDataError(error)));
  };
}

export const fetchUserInfo = () => (dispatch, getState) => {
  const state = getState();
  const isConvergent = getApplicationIsConvergent(state);
  const pricePeriod = getPricePeriod(state);
  const isWithConvergence = isConvergent && !pricePeriod;

  dispatch(fetchData());

  const userInfoBlocks = [
    'ProfileSummary',
    'Balance',
    'Status',
    ...(isWithConvergence ? ['Convergence'] : []),
  ];

  dispatch(fetchUserInfoAction(userInfoBlocks));
};
